import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControlDefinition } from 'src/app/model/form-control-definition';
import { Supplier } from 'src/app/model/supplier';
import { SupplierInterface } from 'src/app/model/supplier-interface';
import { SupplierService } from 'src/app/services/supplier/supplier.service';

@Component({
  selector: 'app-create-supplier-dialog',
  templateUrl: './create-supplier-dialog.component.html',
  styleUrl: './create-supplier-dialog.component.scss'
})
export class CreateSupplierDialogComponent implements OnInit {
  /** Whether submit button was clicked */
  public isSubmitting: boolean = false;

  /** Form group for validation */
  public formGroup: FormGroup = new FormGroup({
    merchantID: new FormControl("", Supplier.validators.get("merchantID")),
    firstName: new FormControl("", Supplier.validators.get("firstName")),
    lastName: new FormControl("", Supplier.validators.get("LastName")),
    emailAddress: new FormControl("", Supplier.validators.get("emailAddress")),
    phoneNumber: new FormControl("", Supplier.validators.get("phoneNumber")),
    streetAddress: new FormControl("", Supplier.validators.get("streetAddress")),
    city: new FormControl("", Supplier.validators.get("city")),
    stateAbbr: new FormControl("", Supplier.validators.get("stateAbbr")),
    postalCode: new FormControl("", Supplier.validators.get("postalCode")),
    status: new FormControl("", Supplier.validators.get("status")),
    macTruckSignupID: new FormControl("", Supplier.validators.get("macTruckSignupID")),
    merchantName: new FormControl("", Supplier.validators.get("merchantName")),
    division: new FormControl("", Supplier.validators.get("division")),
    region: new FormControl("", Supplier.validators.get("region")),
    district: new FormControl("", Supplier.validators.get("district")),
    ownerMerchantID: new FormControl("", Supplier.validators.get("ownerMerchantID")),
    ownerEmail: new FormControl("", Supplier.validators.get("ownerEmail")),
    ownerPhone: new FormControl("", Supplier.validators.get("ownerPhone")),
    statusDate: new FormControl("", Supplier.validators.get("statusDate")),
  });

  /** The form to render */
  public form: FormControlDefinition[] = [
    {
      title: "Supplier ID",
      name: "merchantID",
      type: "number",
      placeholder: "0",
      control: this.formGroup.controls["merchantID"],
      editable: true,
    },
    {
      title: "First Name",
      name: "firstName",
      type: "",
      placeholder: "First Name",
      control: this.formGroup.controls["firstName"],
      editable: true,
    },
    {
      title: "Last Name",
      name: "lastName",
      type: "",
      placeholder: "Last Name",
      control: this.formGroup.controls["lastName"],
      editable: true,
    },
    {
      title: "Email Address",
      name: "emailAddress",
      type: "",
      placeholder: "Email Address",
      control: this.formGroup.controls["emailAddress"],
      editable: true,
    },
    {
      title: "Phone Number",
      name: "phoneNumber",
      type: "tel",
      format: "phone",
      placeholder: "Phone Number",
      control: this.formGroup.controls["phoneNumber"],
      editable: true,
    },
    {
      title: "Street Address",
      name: "streetAddress",
      type: "",
      placeholder: "Street Address",
      control: this.formGroup.controls["streetAddress"],
      editable: true,
    },
    {
      title: "City",
      name: "city",
      type: "",
      placeholder: "City",
      control: this.formGroup.controls["city"],
      editable: true,
    },
    {
      title: "State Abbreviation",
      name: "stateAbbr",
      type: "",
      placeholder: "State Abbreviation",
      control: this.formGroup.controls["stateAbbr"],
      editable: true,
    },
    {
      title: "Postal Code",
      name: "postalCode",
      type: "",
      placeholder: "Postal Code",
      control: this.formGroup.controls["postalCode"],
      editable: true,
    },
    {
      title: "Status",
      name: "status",
      type: "slide",
      placeholder: "",
      control: this.formGroup.controls["status"],
      editable: true,
    },
    {
      title: "Mac Truck Signup ID",
      name: "macTruckSignupID",
      type: "",
      placeholder: "0",
      control: this.formGroup.controls["macTruckSignupID"],
      editable: false,
    },
    {
      title: "Merchant Name",
      name: "merchantName",
      type: "",
      placeholder: "",
      control: this.formGroup.controls["merchantName"],
      editable: true,
    },
    {
      title: "Division",
      name: "division",
      type: "",
      placeholder: "",
      control: this.formGroup.controls["division"],
      editable: true,
    },
    {
      title: "Region",
      name: "region",
      type: "",
      placeholder: "",
      control: this.formGroup.controls["region"],
      editable: true,
    },
    {
      title: "District",
      name: "district",
      type: "",
      placeholder: "",
      control: this.formGroup.controls["district"],
      editable: true,
    },
    {
      title: "Owner Merchant ID",
      name: "ownerMerchantID",
      type: "",
      placeholder: "",
      control: this.formGroup.controls["ownerMerchantID"],
      editable: true,
    },
    {
      title: "Owner Email",
      name: "ownerEmail",
      type: "",
      placeholder: "",
      control: this.formGroup.controls["ownerEmail"],
      editable: true,
    },
    {
      title: "Owner Phone",
      name: "ownerPhone",
      type: "phone",
      placeholder: "",
      control: this.formGroup.controls["ownerPhone"],
      editable: true,
    },
    {
      title: "Status Date",
      name: "statusDate",
      type: "date",
      placeholder: "",
      control: this.formGroup.controls["statusDate"],
      editable: true,
    },
  ];


  /**
   * Default constructor initializes the component with a dialog ref
   * @param dialogRef
   */
  constructor(
    public dialogRef: MatDialogRef<CreateSupplierDialogComponent>,
    private _supplierService: SupplierService,
  ) {
    this.formGroup.setValue({
      merchantID: "",
      firstName: "",
      lastName: "",
      emailAddress: "",
      phoneNumber: "",
      streetAddress: "",
      city: "",
      stateAbbr: "",
      postalCode: "",
      status: true,
      macTruckSignupID: 0,
      merchantName: "",
      division: "",
      region: "",
      district: "",
      ownerMerchantID: "0",
      ownerEmail: "",
      ownerPhone: "",
      statusDate: "",
    });
  }

  /**
   * On init, subscribe to certain form controls to update model data
   */
  public ngOnInit() {
    // Subscribe to merchant ID to check for duplicates
    this.formGroup.get("merchantID")?.valueChanges.subscribe((merchantID: string) => {
      // Don't correlate if the merchant ID is empty
      if (!merchantID || merchantID == '0') return;

      // Determine if a supplier already exists with the same merchant ID
      const supplier = this._supplierService.getSupplierByMerchantId(merchantID);
      if (supplier != undefined) {
        // Set the form control to invalid if a supplier already exists
        this.formGroup.get("merchantID")?.setErrors({ duplicate: true });
      } else {
        // Clear the errors if no supplier exists
        this.formGroup.get("merchantID")?.setErrors(null);
      }
    });

    // Subscribe to the owner merchant ID changes to update the mac truck signup ID
    this.formGroup.get("ownerMerchantID")?.valueChanges.subscribe((ownerID: string) => {
      // Don't correlate if the owner ID is empty
      if (!ownerID || ownerID == '0') return;

      // Find the owner supplier and set signup id
      const ownerSupplier = this._supplierService.getSupplierByMerchantId(ownerID);
      const signupID = ownerSupplier?.macTruckSignupID || 0;
      this.formGroup.get("macTruckSignupID")?.setValue(signupID);
    });
  }

  /**
   * Cancel any changes and close the dialog
   */
  public cancel() {
    this.dialogRef.close(null);
  }

  /**
   * Save the changes to a new supplier and close the dialog
   */
  public save() {
    // Make sure this function can't run twice
    this.isSubmitting = true;
    this.dialogRef.afterClosed().subscribe(() => this.isSubmitting = false);

    // Get the raw data from the form and convert necessary fields
    const raw: any = this.formGroup.getRawValue();
    raw.status = raw.status ? "Active" : "Inactive";
    raw.phoneNumber = raw.phoneNumber != undefined ? raw.phoneNumber.replaceAll(/\D/g, "") : "";
    if (raw.statusDate != undefined) {
      raw.statusDate = raw.statusDate.replaceAll("-", "");

      const year = raw.statusDate.substring(0, 4);
      const month = raw.statusDate.substring(4, 6).replace("0", "");
      const day = raw.statusDate.substring(6, 8).replace("0", "");

      raw.statusDate = `${month}/${day}/${year}`;
    }

    // Create the supplier interface and close the dialog (convert to supplier object first to trim fields)
    const intf: SupplierInterface = raw as SupplierInterface;
    const supplier = new Supplier(intf);
    this.dialogRef.close(supplier.asInterface());
  }
}
